import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Button,
} from 'reactstrap';
import { find } from 'lodash';
import LoadingOverlay from 'react-loading-overlay';
import { useQuery } from 'react-apollo';
import ReactImageFallback from 'react-image-fallback';
import {
  LOGO_LARGE_BLACK, OFFER_TYPE, loaderStyle, FALLBACK_ICON, renderDateRange, capitalizeEveryWord, OFFER_STATUS, BYGMUSIC_CONTRACT, formatedCurrency,
} from '../../../utils';
import { GET_ARTIST_TIMELINE_INFO, GET_OFFER_DETAIL_QUERY } from '../../../graphql-client/queries';
import CampaignTimeline from '../../shared/campaignTimeline/CampaignTimeline';

function Campaign(props) {
  const {
    offerId, artistId,
  } = props;

  const { loading: timelineDataLoading, data: timelineData } = useQuery(
    GET_ARTIST_TIMELINE_INFO,
    {
      variables: { offerId, artistId },
    },
  );

  const { loading: offerDetailLoading, data } = useQuery(
    GET_OFFER_DETAIL_QUERY,
    {
      variables: { offerId, artistId },
    },
  );

  let userIdInfo;
  let contractDate;
  let createMarkup;
  let participantsTimeLine;
  const offerDetail = data && data.offerDetail.data;
  const timelineInfo = timelineData && timelineData.artistTimeLine.data;

  if (timelineInfo) {
    participantsTimeLine = timelineInfo.participantsTimeLine;
    userIdInfo = timelineInfo.userId;
    contractDate = find(participantsTimeLine, { status: OFFER_STATUS.CONTRACT_ACCEPTED });
    createMarkup = () => ({ __html: timelineInfo.createContract });
  }

  return (
    <>
      <LoadingOverlay
        active={timelineDataLoading || offerDetailLoading}
        spinner
        text=""
        className="mainLoader"
        styles={loaderStyle}
      >
        {timelineInfo
        && (
        <div className="campaign">
          <div className="campaign-head">
            <div className="campaign-head-container">
              <Link to="/" className="campaign-head-container-logo">
                <img src={LOGO_LARGE_BLACK} alt="BYGmusic" />
              </Link>
              {offerDetail && (
              <div className="campaign-head-brand">
                <div className="campaign-head-image">
                  <ReactImageFallback
                    src={offerDetail.clientLogo}
                    fallbackImage={FALLBACK_ICON}
                    alt="Offer"
                    className="image-cover"
                  />
                </div>
                <div className="campaign-head-detail">
                  <p>{offerDetail.clientName}</p>
                  <h2>{offerDetail.title}</h2>
                  <span>{OFFER_TYPE[offerDetail.campaignType]}</span>
                  <em>
                    {renderDateRange(offerDetail.offerMinDate, offerDetail.offerMaxDate)}
                  </em>
                </div>
              </div>
              )}
              <div className="campaign-head-btn-group campaign-head-btn-group-print-view">
                <Button
                  type="button"
                  color="publish"
                  className="btn-md"
                  onClick={() => window.print()}
                >
                  Download contract
                </Button>

              </div>
            </div>
          </div>
          <div className="campaign-content">
            <div className="campaign-content-container">
              <div className="campaign-detail campaign-detail-print-view">
                <h3>Contract detail</h3>
                <p dangerouslySetInnerHTML={createMarkup()} />
                {
                  userIdInfo
                && (
                  <div className="contract-data-footer campaign-data-footer">
                    <div className="influencer-data">
                      <h2>{BYGMUSIC_CONTRACT.influencer}</h2>
                      <p>
                        {BYGMUSIC_CONTRACT.name}
                        <span>{userIdInfo.name}</span>
                      </p>
                      <p>
                        {BYGMUSIC_CONTRACT.address}
                        <span>
                          {userIdInfo.city
                            ? `${`${capitalizeEveryWord(`${userIdInfo.city.label}`)}, `}`
                            : ''}
                          {userIdInfo.state
                            ? `${`${capitalizeEveryWord(`${userIdInfo.state.label}`)}, `}`
                            : ''}
                          {userIdInfo.country
                            ? capitalizeEveryWord(`${userIdInfo.country.label}`)
                            : ''}
                        </span>
                      </p>
                      <p>
                        {BYGMUSIC_CONTRACT.emailAddress}
                        <span>{userIdInfo.email}</span>
                      </p>
                    </div>
                    <div className="bygmusic-data">
                      <h2>{BYGMUSIC_CONTRACT.bygMusic}</h2>
                      <p>
                        {BYGMUSIC_CONTRACT.name}
                        <span>{BYGMUSIC_CONTRACT.ownerName}</span>
                      </p>
                      <p>
                        {BYGMUSIC_CONTRACT.title}
                        <span>{BYGMUSIC_CONTRACT.designation}</span>
                      </p>
                    </div>
                  </div>
                )
                }
              </div>
              <div className="campaign-timeline campaign-timeline-print-view">
                <h3>Campaign timeline</h3>
                <div className="campaign-timeline-wrapper">

                  {userIdInfo && (
                  <div className="campaign-timeline-wrapper-user-row mb-3">
                    <span>
                      <ReactImageFallback
                        src={userIdInfo.artistImage}
                        fallbackImage={FALLBACK_ICON}
                        className="image-cover"
                        alt="User"
                      />
                    </span>
                    <p>
                      <em>{capitalizeEveryWord(userIdInfo.name)}</em>
                      {' '}
                      accepted an opportunity for
                      {' '}
                      <em>{`$${formatedCurrency(timelineInfo.basePrice)}`}</em>
                    </p>
                  </div>
                  )}
                  <CampaignTimeline
                    data={timelineInfo.timeline}
                    status={timelineInfo.status}
                    isFromPublicPage
                    contractDate={contractDate}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        )}
      </LoadingOverlay>
    </>
  );
}

Campaign.propTypes = {
  offerId: PropTypes.string.isRequired,
  artistId: PropTypes.string.isRequired,
};

export default Campaign;
